import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { checkApi } from '../../Authentication/AxiosInstance';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { DEFAULT_ACADEMIC_YEAR } from '../../../config/constants';


const SDExamEditForm = ({
  examData, // For edit mode - current exam data
  onSubmit,
  onCancel,
  isSaving
}) => {
  console.log('examData:', examData) // For edit mode - current exam data
  
  const [examOptions, setExamOptions] = useState([]);
  console.log('examOptions:', examOptions)
  const [genderOptions, setGenderOptions] = useState([])
  const [categoryOptions, setCategoryOptions] = useState([])
  const [specialCategoryOptions, setSpecialCategoryOptions] = useState([])
  const selectedGender = examData?.gender?.find(g => g.selected)?.id
  console.log('selectedGender:', selectedGender)
  const { register, handleSubmit, watch} = useForm({
    defaultValues: {
      cndt_exam_id: examData?.cndt_exammaster_id || '', // This will be mapped to cndt_exammaster_id in the backend
      cndt_exam_name: examData?.exam_name || '',
      cndt_exam_session: examData?.exam_session || '',
      cndt_academicyear: examData?.academic_year || '',
      cndt_gender: examData?.gender?.find(g => g.selected)?.id || '',
      cndt_category: examData?.category?.find(c => c.selected)?.id || '',
      candidate_exam_special_category: (() => {
        const specialCategories = [];
        if (examData?.is_pwd) specialCategories.push('PWD');
        if (examData?.is_def) specialCategories.push('DEF');
        if (examData?.is_ews) specialCategories.push('EWS');
        if (examData?.is_orphan) specialCategories.push('ORPHAN');
        if (examData?.is_tfws) specialCategories.push('TFWS');
        return specialCategories;
      })(),
      cndt_exam_strank: examData?.strank || '',
      cndt_exam_airank: examData?.airank || '',
    } 
  });
  console.log('watch("cndt_gender"):', watch('cndt_gender'))
  // Debug: Log form data on submit
  const handleFormSubmit = (data) => {
    data.cndt_academicyear = DEFAULT_ACADEMIC_YEAR;
    console.log('📤 Form submitted with data:', data);
    console.log('📤 cndt_category in submitted data:', data.cndt_category);
    onSubmit(data);
  };

  const fetchExamsMaster = async () => {
    try {
      const response = await checkApi.get("/masters/exammaster/");
      setExamOptions(response.data);
    } catch (error) {
      console.error('Error fetching exams:', error);
    }
  };
  useEffect(() => {
    fetchExamsMaster();
  }, []);

  useEffect(() => {
    examOptions.forEach((exam) => {
      if (exam.id === examData?.cndt_exammaster_id) {
        setGenderOptions(exam.genders)
        setCategoryOptions(exam.general_categories)
        setSpecialCategoryOptions(exam.special_categories)
      }
    })
  }, [examOptions, examData]);

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)} className="space-y-4 p-4">
      {/* Exam Selection */}
      <div className="grid grid-cols-1 md:grid-cols-2 mt-4 mb-2 border-b border-pink-200 pb-2">
        <label className="text-sm font-medium text-gray-700">Exam *</label>
        <input 
            type="text" 
            disabled 
            readOnly
            value={watch('cndt_exam_name')}
            className="col-span-full border border-gray-200 rounded-lg bg-gray-100 text-gray-700"
          />
      </div>

      {/* Categories */}
      {console.log('categoryOptions:', categoryOptions)}
      {categoryOptions.length > 0 && (
        <div className="mb-2 border-b border-pink-200 pb-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">Category</label>
          <div className="grid grid-cols-4">
           {categoryOptions.map((category) => (
                <label key={category.id} className="p-2 col-span-1 space-x-2 border rounded-lg 
                transition-colors cursor-pointer flex items-center hover:border-primary-500 hover:bg-primary-100"
                >
                  <input
                    type="radio"
                    name="cndt_category"
                    value={category.id}
                    {...register('cndt_category')}
                    checked={watch('cndt_category') == category.id}
                    className="text-primary-500 ring-primary-500"
                  />
                  <span className="truncate">{category.category_abbrev}</span>
                </label>
              ))}
          </div>
        </div>
      )}

      {/* Genders */}
      {genderOptions.length > 0 && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Gender</label>
          <div className="grid grid-cols-2 mb-2 border-b border-pink-200 pb-2">
            {genderOptions.map((gender) =>  (
                <label key={gender.id} 
                  className="p-2 col-span-1 space-x-2 border rounded-lg 
                  transition-colors cursor-pointer flex items-center hover:border-primary-500 hover:bg-primary-100"
                >
                  <input
                    type="radio"
                    name="cndt_gender"
                    value={gender.id}
                    {...register('cndt_gender')}
                    checked={watch('cndt_gender') == gender.id}
                    className="text-primary-500 ring-primary-500"
                  />
                  <span className="truncate">{gender.gender_description}</span>
                </label>
             
              ))}
          </div>
        </div>
      )}

      {/* Special Categories */}
      {specialCategoryOptions.length > 0 && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Special Categories</label>
          <div className="grid grid-cols-4 gap-4 border-b border-pink-200 pb-2">
            {specialCategoryOptions.map((category) => (
              console.log('category:', watch('candidate_exam_special_category')),
                <label key={category.category_abbrev}
                  className={`p-2 col-span-1 space-x-2 border rounded-lg 
                              transition-colors cursor-pointer
                              ${watch('candidate_exam_special_category').includes(category.category_abbrev) ? 
                              'border border-primary-500 bg-primary-100 shadow-md' : 
                              'hover:border-primary-300'}`}>
                  <input
                    type="checkbox"
                    value={category.category_abbrev}
                    {...register('candidate_exam_special_category')}
                    checked={watch('candidate_exam_special_category').includes(category.category_abbrev)}
                    className="text-primary-500 ring-primary-500"
                  />
                  <span className="truncate">{category.category_abbrev}</span>
                </label>
              ))}
          </div>
        </div>
      )}

      {/* Ranks */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">All India Rank</label>
          <input
            type="number"
            {...register('cndt_exam_airank')}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            placeholder="Enter All India Rank"
          />
        </div>
        {/* State Rank - Only show for MHTCET exam */}
        {watch('cndt_exam_name') && watch('cndt_exam_name') === 'MHTCET' && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">State Rank</label>
            <input
              type="number"
              {...register('cndt_exam_strank')}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              placeholder="Enter State Rank"
            />
          </div>
        )}
      </div>

      {/* Buttons */}
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:space-x-4 pt-4">
        <button
          type="submit"
          disabled={isSaving}
          className="buttonClass w-full md:w-auto flex items-center justify-center space-x-2 px-6 py-2 transition-colors disabled:opacity-50"
        >
          {isSaving ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
              <span>Saving...</span>
            </>
          ) : (
            <>
              <CheckIcon className="w-4 h-4" />
              <span>'Update Exam'</span>
            </>
          )}
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="buttonClass w-full md:w-auto flex items-center justify-center space-x-2 px-6 py-2 transition-colors"
        >
          <XMarkIcon className="w-4 h-4" />
          <span>Cancel</span>
        </button>
      </div>
    </form>
  );
};

export default SDExamEditForm;
